import type {Nullable} from '../utility-types';

import {currentUserStore, type UserApiModel} from '../../api/user';

type TargetCoCoachEntity = Nullable<{
  coach_ids?: string[];
  user?: Nullable<UserApiModel>;
}>;

type TargetEntity = Nullable<{
  coach_ids?: string[];
}>;

export const isMeCoachForEntity = (entity?: TargetEntity): boolean => {
  return !!entity?.coach_ids?.includes(currentUserStore.user?._id || '');
};

export const isMeCoCoachForEntity = (entity?: TargetCoCoachEntity): boolean => {
  return (
    isMeCoachForEntity(entity) &&
    entity?.user?._id !== currentUserStore.user?._id
  );
};
